import { ErrorType } from 'src/app/core/routing/error-types';
import { ToastService } from '../../base/services/toast.service';
import { ClientService } from '../../base/services/client/client.service';
import { FilterOperator, ZoneDamageClient, ZoneDamageDTO } from '../../base/models/models.swagger.generated';
import { Injectable } from '@angular/core';
import { Observable, of, throwError } from 'rxjs';
import { FilterDTO, PagedResultDTOOfZoneDamageDTO, SortDirection } from 'src/app/base/models/models.swagger.generated';
import { ShowInactiveService } from 'src/app/base/shared/grid-base/show-inactive.service';
import { IAdaptorService } from 'src/app/base/shared/syncfusion/adaptor-service.interface';
import { catchError, tap } from 'rxjs/operators';
import { FilterUtil } from 'src/app/base/shared/filter-util';
import { DATE_HELPER_DEFAULT_TIME_ZONE } from 'src/app/base/shared/date-helper';

@Injectable()
export class ZoneDamageService extends ShowInactiveService implements IAdaptorService {

  public filters: FilterDTO[] = [];

  constructor(private zoneDamageClient: ZoneDamageClient,
              private clientService: ClientService,
              private toastService: ToastService) {
    super();
  }

  // eslint-disable-next-line max-len
  public getData(skip: number, take: number, filters: FilterDTO[], sortBy: string, sortDirection: SortDirection): Observable<PagedResultDTOOfZoneDamageDTO> {
    if (!sortBy) {
      sortBy = 'Id';
    }
    if (!filters) {
      filters = [];
    }
    if (!this.showInactive) {
      filters.push(new FilterDTO({isComplex: false, field: 'Active', operator: FilterOperator.Equal, value: 'true'}));
    }
    filters.push(...this.filters);
    FilterUtil.correctDateTimeFilters(filters, 'reportTime', DATE_HELPER_DEFAULT_TIME_ZONE);
    if (!this.clientService.selectedClient) {
      return of(null);
    }
    return this.zoneDamageClient.searchDamages(this.clientService.selectedClient?.id, filters, skip, take, sortBy, sortDirection);
  }

  public addRecord(data: any): Observable<ZoneDamageDTO> {
    return this.zoneDamageClient.addDamage(data)
      .pipe(
        tap(() => {
          this.toastService.showSuccess(
            'i18n.domain.zone-damage.messages.add-title',
            'i18n.domain.zone-damage.messages.add-success-message',
          );
        }),
        catchError(error => {
          if (!this.toastService.doesErrorExistAlready(ErrorType.serverError)) {
            this.toastService.showError('i18n.errors.server-error.title', 'i18n.errors.server-error.message', null, ErrorType.serverError);
          }
          return throwError(() => error);
        }),
      );
  }

  public updateRecord(data: any): Observable<ZoneDamageDTO> {
    return this.zoneDamageClient.updateDamage(data)
      .pipe(
        tap(() => {
          this.toastService.showSuccess(
            'i18n.domain.zone-damage.messages.edit-title',
            'i18n.domain.zone-damage.messages.edit-success-message',
          );
        }),
        catchError(error => {
          if (!this.toastService.doesErrorExistAlready(ErrorType.serverError)) {
            this.toastService.showError('i18n.errors.server-error.title', 'i18n.errors.server-error.message', null, ErrorType.serverError);
          }
          return throwError(() => error);
        }),
      );
  }

  public deleteRecord(id: number): Observable<void> {
    return this.zoneDamageClient.deleteDamage(id)
      .pipe(
        tap(() => {
          this.toastService.showSuccess(
            'i18n.domain.parker-administration.messages.delete-title',
            'i18n.domain.parker-administration.messages.delete-success-message',
          );
        }),
        catchError(error => {
          if (!this.toastService.doesErrorExistAlready(ErrorType.serverError)) {
            this.toastService.showError('i18n.errors.server-error.title', 'i18n.errors.server-error.message', null, ErrorType.serverError);
          }
          return throwError(() => error);
        }),
      );
  }
}
